import React from "react";
import artImage from '../../images/tableaux.JPG';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function ArtPage() {
    const seo = CATEGORIES_SEO.art;
    const details = [
        "Aquarelles",
        "Cadres anciens",
        "Peintures à l’huile anciennes",
        "Photos anciennes",
        "Impressions et lithographies",
        "Encadrements et styles particuliers",
        "Tableaux de peintres d’époque",
        "Œuvres de grands maîtres européens",
        "Créations emblématiques d’Asie, d’Afrique ou d’Océanie",
        "Œuvres d’artistes contemporains américains",
        "Pièces nécessitant une restauration ou en excellent état",
    ];

    return (
        <CategoryPage
            title="Œuvres d'Art"
            image={artImage}
            description="Je me présente en tant qu'antiquaire spécialisé dans l'acquisition et la valorisation des peintures anciennes et tableaux d'époque. Mon travail consiste à découvrir et à préserver ces trésors du passé, en leur offrant une seconde vie, même s'ils nécessitent une restauration. Si vous possédez des œuvres d'art, qu'elles soient en parfait état ou à restaurer, je serais ravi de les examiner avec la plus grande attention. Appelez-moi dès aujourd'hui pour discuter de vos pièces. Ensemble, nous pourrons leur offrir un avenir qui leur rendra hommage."
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default ArtPage;
